import axios from 'axios'
import {
    SECTIONS_LIST_REQUEST, SECTIONS_LIST_SUCCESS, SECTIONS_LIST_FAIL,
    SECTION_DETAIL_REQUEST, SECTION_DETAIL_SUCCESS, SECTION_DETAIL_FAIL,
    QUIZ_FETCH_REQUEST, QUIZ_FETCH_SUCCESS, QUIZ_FETCH_FAIL,
    QUIZ_SUBMIT_REQUEST, QUIZ_SUBMIT_SUCCESS, QUIZ_SUBMIT_FAIL,
} from '../constants/courseConstants'

export const listSections = () => async (dispatch, getState) => {
    try {
        dispatch({ type: SECTIONS_LIST_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const config = { headers: { Authorization: `Bearer ${userInfo.token}` } }
        const { data } = await axios.get('/api/sections/', config)
        dispatch({ type: SECTIONS_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: SECTIONS_LIST_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const getSectionDetail = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: SECTION_DETAIL_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const config = { headers: { Authorization: `Bearer ${userInfo.token}` } }
        const { data } = await axios.get(`/api/sections/${id}/`, config)
        dispatch({ type: SECTION_DETAIL_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: SECTION_DETAIL_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const fetchQuiz = (sectionId) => async (dispatch, getState) => {
    try {
        dispatch({ type: QUIZ_FETCH_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const config = { headers: { Authorization: `Bearer ${userInfo.token}` } }
        const { data } = await axios.get(`/api/quiz/${sectionId}/`, config)
        dispatch({ type: QUIZ_FETCH_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: QUIZ_FETCH_FAIL, payload: error.response?.data?.detail || error.message })
    }
}

export const submitQuiz = (sectionId, answers) => async (dispatch, getState) => {
    try {
        dispatch({ type: QUIZ_SUBMIT_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const config = { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${userInfo.token}` } }
        const { data } = await axios.post(`/api/quiz/${sectionId}/submit/`, { answers }, config)
        dispatch({ type: QUIZ_SUBMIT_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: QUIZ_SUBMIT_FAIL, payload: error.response?.data?.detail || error.message })
    }
}
